export const FACILITY_TYPE = {
  Hospital: 'Hospital',
  SkilledNursing: 'Skilled Nursing',
  AssistedLiving: 'Assisted Living',
  IndependentLiving: 'Independent Living',
  InpatientRehab: 'Inpatient Rehab',
  InpatientPsych: 'Inpatient Psych',
  Inpatient: 'Inpatient',
};
